import React, { useContext, useMemo } from "react";
import { useEffect, useState, useRef } from "react";
import axios from "axios";
import addentryimage from "../images/horse.png";
import classadddropimage from "../images/class.png";
import ordersupplyimage from "../images/order.png";
import checkoutimage from "../images/cart.png";
import digisignimage from "../images/signature.png";
import liveclassimage from "../images/live2.png";
import userimage from "../images/user.png";
import SglContext from "../SglContext";
import SglCart from "./SglCart"; // Import the cart component
import { useNavigate, useLocation, matchPath } from "react-router-dom";
import { Link } from "react-router-dom";
import './topheader.css';

function LogOutRoute(props) {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.referrer) {
      let ref = window.referrer;
      window.referrer = "";
      setTimeout(() => {
        navigate(ref);
      }, 500);
    } else {
      window.location.href = props.basePath;
    }
  }, []);
  return <></>;
}
export { LogOutRoute };

function SglActions(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const [userDisplayName, setUserDisplayName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [showCart, setShowCart] = useState(false); // State to control cart visibility
  const Sgl = useContext(SglContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [teamsToShow, setTeamsToShow] = useState([]);
  const [isUserVerified, setIsUserVerified] = useState(false);

  // Check if Supply Ordering Commerce System is enabled
  const checkSupplyOrderingSwitch = () => {
    if (!Sgl.switches || !Sgl.switches.switches) {
      return false;
    }
    
    const supplySwitch = Sgl.switches.switches.find(
      switchItem => switchItem.switch_name === 'Supply Ordering Commerce System'
    );

    return supplySwitch && supplySwitch.value == 1;
  };

  useEffect(() => {
    setShowCart(checkSupplyOrderingSwitch());
  }, [Sgl.switches]);

  useEffect(() => {
    const loadTeams = () => {
      const myTeams = localStorage.getItem("userTeams");
      let teams = [];
      if (myTeams) {
        try {
          teams = JSON.parse(myTeams);
          if (!Array.isArray(teams)) {
            console.warn("Expected an array of teams, got:", teams);
            teams = [];
          }
        } catch (e) {
          console.error("Error parsing userTeams:", e);
        }
      }

      const hasOwnerTeam = teams.some(team => team.isOwner === true);

      const teamsToShow = hasOwnerTeam ? teams : [{ teamId: 'personal', name: userDisplayName, role: 'personal', isOwner: true },{ teamId: 'create', name: 'Create My Team', role: 'create', isOwner: false }, ...teams];
      setTeamsToShow(teamsToShow);
    }
    if(isLoggedIn){
      loadTeams();
    }
  }, [isLoggedIn, Sgl.userTeams])

  useEffect(() => {
    if (Sgl.current_user && Sgl.current_user != null) {
      var user_display_name =
        Sgl.current_user.first + " " + Sgl.current_user.last_name;
      var user_email = Sgl.current_user.email_address;

      var is_verified = Sgl.current_user.userVerfied || false;
        
      setIsLoggedIn(true);
      setUserDisplayName(user_display_name);
      setUserEmail(user_email);
      setIsUserVerified(is_verified);
      localStorage.setItem("user_display_name", user_display_name);
      localStorage.setItem("user_email", user_email);

      var divs = document.getElementsByClassName("logged-in-state");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "visible";
        divs[i].style.display = "block";
      }
      var divs = document.getElementsByClassName("logged-out-state");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "hidden";
        divs[i].style.display = "none";
      }
    } else {
      setIsLoggedIn(false);
      setUserDisplayName("");
      setUserEmail("");
      setIsUserVerified(false);

      var divs = document.getElementsByClassName("logged-in-state");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "hidden";
        divs[i].style.display = "none";
      }
      var divs = document.getElementsByClassName("logged-out-state");
      for (var i = 0; i < divs.length; i++) {
        divs[i].style.visibility = "visible";
        divs[i].style.display = "block";
      }
    }
  }, [props]);

  function logoutUser() {
    axios.get(Sgl.nestApiUrl + "/auth/logout").then(
      (response) => {
        if (response.data.logout) {
          axios
            .post(
              Sgl.sglApiUrl +
                "/iphone.php/webservice/LogoutSGLAPIUser",
              {},
              { headers: { "Content-Type": "application/json" } }
            )
            .then((res) => {
              setIsLoggedIn(false);
              setUserDisplayName("");
              setUserEmail("");

              localStorage.removeItem("user_display_name");
              localStorage.removeItem("user_email");
              localStorage.removeItem("access_token");
              // Clear cart data on logout
              localStorage.removeItem("selected_showfees");
              localStorage.removeItem("selected_showfees_show");
              localStorage.removeItem("selected_showfees_showid");

              // Trigger cart update event to refresh cart UI
              window.dispatchEvent(new Event('cartUpdated'));
              
              Sgl.setVerificationStatus("");
              window.referrer =
                window.location.pathname.replace(props.basePath, "") +
                window.location.search;
              Sgl.getUser();
              navigate("/");
            });
        }
      },
      (error) => {}
    );
  }

  useEffect(() => {
    // Create a global logout function that WordPress can call
    window.sglLogoutUser = () => {
      axios.get(Sgl.nestApiUrl + "/auth/logout").then(
        (response) => {
          if (response.data.logout) {
            axios
              .post(
                Sgl.sglApiUrl + "/iphone.php/webservice/LogoutSGLAPIUser",
                {},
                { headers: { "Content-Type": "application/json" } }
              )
              .then((res) => {
                // Clear localStorage
                localStorage.removeItem("user_display_name");
                localStorage.removeItem("user_email");
                localStorage.removeItem("user_id");
                localStorage.removeItem("access_token");
                localStorage.removeItem("selected_showfees");
                localStorage.removeItem("selected_showfees_show");
                localStorage.removeItem("selected_showfees_showid");
                localStorage.removeItem("userTeams");
                localStorage.removeItem("currentTeamId");

                // Trigger cart update event
                window.dispatchEvent(new Event('cartUpdated'));
                
                // Reload the page to reset all React state
                window.location.reload();
              });
          }
        },
        (error) => {
          console.error('Logout error:', error);
        }
      );
    };

    // Cleanup function
    return () => {
      if (window.sglLogoutUser) {
        delete window.sglLogoutUser;
      }
    };
  }, []);
  
  const handleTeamSwitch = (teamId) => { 
    // Ensure we store as string to match localStorage behavior
    const teamIdString = String(teamId);
    
    // Update SglContext
    if (Sgl.setCurrentTeamId) {
      Sgl.setCurrentTeamId(teamIdString);
    }
  }

  function closePopup() {
    var popup = document.getElementById("myPopup");
    popup.classList.remove("show");
    document.getElementById("live-classes-popup-overlay").style.display =
      "none";
    popup.innerHTML = '<div class="popup-loader"></div>';
  }

  // Helper functions to determine UI state
  const getUIState = () => {
    const hasOwnerTeam = teamsToShow?.some(team => team.isOwner && team.teamId !== 'personal');
    const hasJoinedTeams = teamsToShow?.some(team => !team.isOwner && team.teamId !== 'create');
    
    if (hasJoinedTeams) {
      return 'has_joined_teams'; // Show team switcher
    } else if (hasOwnerTeam) {
      return 'has_owner_team'; // User created a team
    } else {
      return 'default'; // No teams - show create team link
    }
  };

  const getSelectedTeam = () => {
    return teamsToShow?.find(team => team.teamId === Sgl.currentTeamId || team.teamId == Sgl.currentTeamId);
  };

  const getTeamRoleDisplay = () => {
    const selectedTeam = getSelectedTeam();
    if (!selectedTeam) return '';
    
    if (selectedTeam.isOwner && selectedTeam.teamId !== 'personal') {
      return `${selectedTeam.name} - Owner`;
    } else if (!selectedTeam.isOwner && selectedTeam.teamId !== 'personal') {
      return `${selectedTeam.name} - ${selectedTeam.role?.name}`;
    }
    return '';
  };

  const shouldShowNewBadge = () => {
    const selectedTeam = getSelectedTeam();
    // Only show NEW badge if we have team scenarios AND it's not the personal account
    if (uiState === 'default') return false; // No teams at all
    
    // For team switcher scenario, check if personal account is selected
    if (uiState === 'has_joined_teams') {
      return Sgl.currentTeamId !== 'personal' && selectedTeam?.teamId !== 'personal';
    }
    
    // For owner team scenario, check if personal account is selected  
    if (uiState === 'has_owner_team') {
      return Sgl.currentTeamId !== 'personal' && selectedTeam?.teamId !== 'personal';
    }
    
    return false;
  };

  const uiState = getUIState();

  if(props.company_id == -1){
    return <></>;
  }

  return (
    <>
      {/* NEW Navigation */}
      <div className="premium-topbar-container">
        <div className={`premium-sophisticated-header ${isLoggedIn === true ? 'logged-in' : 'logged-out'}`}>
          <div className="premium-user-info-sophisticated">
            
            {/* User name and verification - always shown when logged in */}
            {isLoggedIn === true && uiState !== 'has_joined_teams' && (
              <div className="user-main-info">
                <div className="user-info-with-verification">
                  <span className="user-full-name">{userDisplayName}</span>
                  {isUserVerified && (
                    <span className="verified-icon">
                      <i className="fas fa-check">&nbsp;</i>
                    </span>
                  )}
                </div>
              </div>
            )}

            {/* Team Switcher - only show when user has joined other teams */}
            {isLoggedIn === true && uiState === 'has_joined_teams' && (
              <div className="user-main-info">
                <TeamSwitcher 
                  userDisplayName={userDisplayName}
                  userTeams={teamsToShow}
                  currentTeamId={Sgl.currentTeamId}
                  onTeamSwitch={handleTeamSwitch}
                  isUserVerified={isUserVerified}
                />
              </div>
            )}

            {/* Secondary info line */}
            {(() => {
              const teamRoleContent = getTeamRoleDisplay();
              const hasTeamRole = isLoggedIn === true && (uiState === 'has_owner_team' || uiState === 'has_joined_teams') && teamRoleContent;
              const hasCreateTeamLink = isLoggedIn === true && uiState === 'default';
              const hasContent = hasTeamRole || hasCreateTeamLink;
              
              return (
                <div className={`secondary-info ${!hasContent ? 'empty' : ''}`}>
                  {/* Team role display - show for owner team or selected joined team */}
                  {hasTeamRole && (
                    <>
                    <div className="team-role-display">
                      {teamRoleContent}
                    </div>
                    {shouldShowNewBadge() && (
                        <span className="new-badge">NEW</span>
                    )}
                    </>
                  )}

                  {/* Create My Team link - only show in default state */}
                  {hasCreateTeamLink && (
                    <Link
                      to='/edit-account/#team_management'
                      state={{ showCreateForm: true }}
                      onClick={() => {
                        // If already on edit-account page, force hash change
                        if (location.pathname === '/edit-account/') {
                          window.location.hash = '';
                          setTimeout(() => {
                            window.location.hash = 'team_management';
                          }, 1);
                        }
                      }}
                      className='create-team-link'>
                      Create My Team
                      <span className="new-badge">NEW</span>
                    </Link>
                  )}
                </div>
              );
            })()}
          </div>
          
          <div className="premium-user-actions-sophisticated">
            {isLoggedIn === true && (
              <button
                onClick={() => navigate("/edit-account/")}
                className='premium-user-btn-sophisticated logged-in-state'>
                MY ACCOUNT
                {(Sgl.pendingRequestsCount + Sgl.pendingAgreementsCount) > 0 && (
                  <span className="notification-badge">
                    {Sgl.pendingRequestsCount + Sgl.pendingAgreementsCount}
                  </span>
                )}
              </button>
            )}
            {isLoggedIn === true && (
              <button
                className='premium-user-btn-sophisticated logged-in-state'
                onClick={logoutUser}>
                LOGOUT
              </button>
            )}
            {isLoggedIn === false && (
              <>
                <Link
                  to='/login/'
                  className='premium-user-btn-sophisticated logged-out-state'>
                  LOGIN
                </Link>
                <Link
                  to='/registration/'
                  className='premium-user-btn-sophisticated logged-out-state'>
                  REGISTER
                </Link>
              </>
            )}

            {showCart && <SglCart />}
          </div>
        </div>

        <div className="premium-nav-premium">
          <div className="premium-nav-grid-premium">
            <Link 
              className={`premium-nav-item-premium ${
                matchPath("/add-entry", location.pathname) ? "active" : ""
              }`}
              to='/add-entry/'>
              <div className="premium-nav-icon-premium">
                <img style={{ width: "16px" }} src={addentryimage} />
              </div>
              <div className="premium-nav-text-group-premium">
                <div className="premium-nav-label-premium">ADD</div>
                <div className="premium-nav-sublabel-premium">ENTRY</div>
              </div>
            </Link>

            <Link 
              className={`premium-nav-item-premium ${
                matchPath("/class-adds-drops", location.pathname) ? "active" : ""
              }`}
              to='/class-adds-drops/'>
              <div className="premium-nav-icon-premium">
                <img style={{ width: "15px" }} src={classadddropimage} />
              </div>
              <div className="premium-nav-text-group-premium">
                <div className="premium-nav-label-premium">CLASS</div>
                <div className="premium-nav-sublabel-premium">ADDS/DROPS</div>
              </div>
            </Link>

            <Link 
              className={`premium-nav-item-premium ${
                matchPath("/order-supplies", location.pathname) ? "active" : ""
              }`}
              to='/order-supplies/'>
              <div className="premium-nav-icon-premium">
                <img style={{ height: "15px" }} src={ordersupplyimage} />
              </div>
              <div className="premium-nav-text-group-premium">
                <div className="premium-nav-label-premium">ORDER</div>
                <div className="premium-nav-sublabel-premium">SUPPLIES</div>
              </div>
            </Link>

            <Link 
              className={`premium-nav-item-premium ${
                matchPath("/checkout-entries", location.pathname) ? "active" : ""
              }`}
              to='/checkout-entries/'>
              <div className="premium-nav-icon-premium">
                <img style={{ width: "14px" }} src={checkoutimage} />
              </div>
              <div className="premium-nav-text-group-premium">
                <div className="premium-nav-label-premium">CHECKOUT</div>
                <div className="premium-nav-sublabel-premium">ENTRIES</div>
              </div>
            </Link>

            <Link 
              className={`premium-nav-item-premium ${
                matchPath("/digital-signature", location.pathname) ? "active" : ""
              }`}
              to='/digital-signature/'>
              <div className="premium-nav-icon-premium">
                <img style={{ width: "16px" }} src={digisignimage} />
              </div>
              <div className="premium-nav-text-group-premium">
                <div className="premium-nav-label-premium">DIGITAL</div>
                <div className="premium-nav-sublabel-premium">SIGNATURE</div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

const TeamSwitcher = ({ userDisplayName, userTeams, currentTeamId, onTeamSwitch, isUserVerified }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  
  // Filter teams for dropdown display
  const personalTeam = { teamId: 'personal', name: userDisplayName, role: 'personal', isOwner: true };
  const ownedTeam = userTeams?.find(team => team.isOwner && team.teamId !== 'personal');
  const joinedTeams = userTeams?.filter(team => !team.isOwner && team.teamId !== 'create') || [];
  const hasOwnerTeam = !!ownedTeam;
  
  // Build dropdown options
  const dropdownOptions = [
    personalTeam,
    ...(ownedTeam ? [ownedTeam] : []),
    ...joinedTeams,
    ...(!hasOwnerTeam ? [{ teamId: 'create', name: 'Create My Team', role: 'create', isOwner: false }] : [])
  ];

  const selectedTeam = userTeams?.find(team => team.teamId === currentTeamId || team.teamId == currentTeamId) || personalTeam;

  const handleClick = () => {
    setIsOpen(prev => !prev);
  };

  const handleTeamClick = (teamId) => {
    setIsOpen(false);

    if (teamId === 'create') {
      // Check if already on edit-account page
      if (window.location.pathname === '/edit-account/') {
        // Force hash change like the working button does
        window.location.hash = '';
        setTimeout(() => {
          window.location.hash = 'team_management';
        }, 1);
      } else {
        // Navigate normally if not on edit-account page
        navigate('/edit-account/#team_management', { state: { showCreateForm: true } });
      }
    } else {
      onTeamSwitch(teamId);
    }
  };

  useEffect(() => {
    if (!isOpen) return;

    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => document.removeEventListener('mousedown', handleOutsideClick);
  }, [isOpen]);

  return (
    <div ref={dropdownRef} className="team-switcher" onClick={handleClick}>
      <div className="team-switcher-content">
        <div className="team-switcher-name">
          <span className="user-name">{userDisplayName}</span>
        </div>
      </div>
      <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      {isUserVerified && (
        <span className="verified-icon">
          <i className="fas fa-check">&nbsp;</i>
        </span>
      )}

      {isOpen && (
        <div className="team-switcher-dropdown">
          {dropdownOptions.map(team => (
            <div
              key={team.teamId}
              onClick={(e) => {
                e.stopPropagation();
                handleTeamClick(team.teamId);
              }}
              className={`dropdown-item ${currentTeamId === team.teamId ? 'selected' : ''}`}
            >
              <div className="dropdown-item-left">
                <span>
                  {team.teamId === 'personal' ? '👤' : team.teamId === 'create' ? '➕' : '👥'}
                </span>
                <span>
                  {team.teamId === 'personal' ? userDisplayName : team.name}
                </span>
              </div>
              {team.teamId !== 'personal' && team.teamId !== 'create' && (
                <span className="dropdown-item-right">
                  {team.isOwner ? 'Owner' : (team.role?.name || 'Member')}
                </span>
              )}
            </div>
          ))}

          {dropdownOptions.length === 0 && (
            <div className="dropdown-item" style={{ 
              color: '#999', 
              fontStyle: 'italic' 
            }}>
              No teams available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SglActions;